import { writable } from 'svelte/store';

import { billingRefusalDetails, domainErrorKind } from '$lib/api-error-kind';
import { billingRefusalOf, type BillingRefusal } from '$lib/chat/billing-refusal';

// Running a skill or plugin binary or script: what the media studios (image, sound, music, voice)
// and the publishing and playtest plugins call.
const RUN_PATH = /\/actions\/run-(?:binary|script)$/;

/**
 * The billing refusal behind a failed run (a 402 on a run operation), or `undefined` for any other
 * response. A refusal needs its payer to be told apart from a plain error: an exhausted balance
 * without one (and any other 402 `kind`) is left to the caller's own message.
 */
export function refusedRunOf(
	request: Pick<Request, 'url'> | undefined,
	response: Pick<Response, 'status'> | undefined,
	body: unknown,
): BillingRefusal | undefined {
	if (response?.status !== 402 || !request) return undefined;
	if (!RUN_PATH.test(new URL(request.url, 'http://localhost').pathname)) return undefined;
	return billingRefusalOf({
		status: 'error',
		error_kind: domainErrorKind(body),
		error_payer: billingRefusalDetails(body).payer,
	});
}

/**
 * The latest paid run the billing gate refused. `RefusedRunDialog` shows what to do about it and
 * clears it; the studios keep reporting the run's own error where they were showing it.
 */
export const refusedRun = writable<BillingRefusal | undefined>(undefined);
